"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BBAuthGuardService = void 0;
const router_1 = require("@angular/router");
const roles_helper_service_1 = require("./roles-helper.service");
class BBAuthGuardService {
    constructor(router, rolesService) {
        this.router = router;
        this.rolesService = rolesService;
    }
    canActivate(route, state) {
        const roles = route.data['roles'];
        if (this.rolesService !== null && this.rolesService !== undefined) {
            if (this.rolesService.getRolesPermission(roles)) {
                return true;
            }
            else {
                return localStorage.getItem('profileType') === 'PRIMARY' || localStorage.getItem('profileType') === 'SECONDARY' ? true : false;
            }
        }
    }
}
exports.BBAuthGuardService = BBAuthGuardService;
//# sourceMappingURL=bbrolesauthservice.service.js.map